<template>
  <div>
    <div class="">
      <!-- <div class="handle-box">
        <el-input
          size="small"
          placeholder="团体名称"
          v-model.trim="name"
          class="handle-input mr10"
        ></el-input>
      </div> -->
      <el-table
        :data="data.records"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column header-align="center" label="用户名" prop="targetName">
        </el-table-column>
        <el-table-column
          prop="targetCode"
          label="身份证号"
          align="center"
        ></el-table-column>
        <!-- <el-table-column label="备注" header-align="center" prop="remark">
        </el-table-column> -->
        <el-table-column label="注销时间" align="center">
          <template #default="scope">
            {{ $utils.formatDate(scope.row.createTime, "yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="data.current"
          :page-size="20"
          :total="data.total"
          @current-change="getData"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      name: "",
      loading: false,
      payment_dialog: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      if (this.name.length > 40) {
        this.$message.warning("搜索条件不能超过40个字");
        return;
      }
      try {
        const params = {
          targetType: 1,
          currentPage: page,
          pageSize: 20,
        };
        this.$loading.start();
        const res = await this.$api.logOff.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
  },
  watch: {
    name: {
      handler(val, ovl) {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 300px;
  display: inline-block;
}

.handle-select {
  width: 150px;
}

.handle-box {
  margin-bottom: 20px;
}

.payment_dialog-body {
  embed {
    width: 100%;
    height: 800px;
  }
  img {
    width: 100%;
  }
}
</style>


